import heroimg from "../../../../../images/LandingPageImage/mn_whatsapp_campaign.webp";
import "../../styles/LandingPageCss/MainHomeSection.css";
import FAQContactSection from "../LandingPagecomponents/FAQContactSection";
import google from "../../../../../images/LandingPageImage/google.png";
import { useModal } from "../../../../../MyContext";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";

export default function WhatsAppCampaign() {
  const { openModal } = useModal();
  return (
    <div>
      <Navbar />
      <section className="hero-section py-5 py-md-6 font-inter">
        <div className="container px-3 px-lg-4">
          <div className="row align-items-center gx-lg-5 gy-5">
            <div className="col-12 col-md-6 order-2 order-md-1">
              <div className="hero-content text-center text-md-start">
                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                  WhatsApp Campaign: The Intelligent Alternative to Reach,
                  Engage and Convert Customers
                </h1>

                <p className="hero-subtitle mt-3">
                  In the modern digitalized high-paced world, companies require
                  fast, one-on-one and high-conversion communication channels.
                  One of the most effective tools of reaching customers in real
                  time has become a WhatsApp campaign. Having the highest open
                  rates among other existing email and SMS marketing platforms,
                  WhatsApp can enable brands to communicate with people at the
                  most active place.
                </p>

                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                  <Link
                    to="/login"
                    className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{ width: "30px", height: "30px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "20px", height: "20px" }}
                        className="img-fluid"
                      />
                    </span>

                    <span className="text-nowrap fs-6">Start With Google</span>
                  </Link>
                  <button
                    onClick={openModal}
                    className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                  >
                    <span className="text-nowrap fs-5">Book a Demo</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 order-2 order-md-2">
              <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                <div className="hero-circle-bg">
                  <div className="circle-element "></div>
                  <img
                    src={heroimg}
                    alt="WhatsApp marketing dashboard"
                    className="hero-img img-fluid  rounded-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            What Is a WhatsApp Campaign?
          </h1>

          <p className="about-text text-dark">
            WhatsApp campaign refers to a systematic marketing strategy that
            involves companies sending personalized messages, deals,
            information, or messages to the customer via WhatsApp. However, in
            contrast to generic messaging, a properly designed whatsapp
            marketing campaign is based on the concept of personalization,
            timing and relevance to initiate meaningful conversations.
          </p>

          <p className="about-text text-dark mb-5">
            Companies in industries such as startups to big companies are
            employing WhatsApp to send offer messages, delivery messages,
            reminders, and customer care messages effectively.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card mb-5 text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  Why WhatsApp Marketing is important to businesses
                </h3>
                <p>
                  WhatsApp marketing offers businesses a powerful way to connect
                  with customers through high open rates, real-time engagement,
                  and cost-effective communication. With support for multimedia
                  sharing such as images, videos, and documents, brands can
                  deliver richer messages that drive stronger responses.
                  Automation further simplifies customer interactions, allowing
                  businesses to scale campaigns efficiently while maintaining
                  personalization.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card mb-5 text-start  mission-card">
                <h3 className="font-spacegrotesk text-dark">
                  WhatsApp Marketing Campaigns through MsgNotifier
                </h3>
                <p>
                  We offer premium software at MsgNotifier to make you create an
                  effective whatsapp marketing campaign. We have a platform
                  through which we can support bulk messaging, automation,
                  message scheduling and detailed analytics which will enhance
                  the performance of the campaigns.
                </p>
                <p>
                  You need to advertise a new product launch or massacre festive
                  offers, then our solution will make it easy to run a whatsapp
                  promotional campaign and easily scale it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            WhatsApp is an Ecommerce
            <br />
            Businesses Campaign
          </h1>

          <p className="about-text text-dark mb-5">
            WhatsApp marketing enables businesses to engage customers instantly
            with higher open and response rates compared to traditional
            channels. It supports real-time conversations, rich multimedia
            sharing, and personalized communication that feels natural and
            non-intrusive.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="info-card bg-lavender text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  Drive More Sales with Direct Customer Engagement
                </h3>
                <p>
                  WhatsApp allows e-commerce businesses to connect directly with
                  shoppers through personalized messages, offers, and product
                  recommendations. This one-to-one communication builds trust
                  and significantly improves conversion rates compared to
                  traditional channels.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card text-start bg-adonis  ">
                <h3 className="font-spacegrotesk text-dark">
                  Reduce Cart Abandonment with Real-Time Notifications
                </h3>
                <p>
                  Automated WhatsApp messages help recover abandoned carts by
                  sending timely reminders, order confirmations, and payment
                  alerts. These instant updates encourage customers to complete
                  purchases and improve overall sales performance.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card text-start bg-coral  mission-card">
                <h3 className="font-spacegrotesk text-dark">
                  Enhance Customer Experience with Post-Purchase Support
                </h3>
                <p>
                  From order confirmations to delivery updates and return
                  assistance, WhatsApp keeps customers informed at every stage.
                  This seamless post-purchase communication increases customer
                  satisfaction, repeat purchases, and long-term brand loyalty.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            Why MsgNotifier Team WhatsApp <br></br> Campaigns?
          </h1>

          <p className="about-text text-dark mb-5">
            MsgNotifier is designed to simplify and scale WhatsApp marketing for
            businesses of all sizes. Whether you are launching your first
            WhatsApp campaign for e-commerce or managing enterprise-level
            customer communication, our platform provides everything you need in
            one place.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Easy WhatsApp API Integration
                </h3>
                <p className="text-white">
                  MsgNotifier enables quick and hassle-free integration with the
                  official WhatsApp Business API. Businesses can start campaigns
                  faster without technical complexity or long setup times.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Bulk & Automated Messaging
                </h3>
                <p className="text-white">
                  Reach thousands of customers instantly with bulk messaging and
                  smart automation. Schedule campaigns, send reminders, and
                  trigger messages automatically to save time and improve
                  engagement.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Secure and Policy-Compliant Campaigns
                </h3>
                <p className="text-white">
                  All campaigns are built to follow WhatsApp’s messaging
                  policies and security standards. This ensures high delivery
                  rates while protecting your brand reputation.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Advanced Analytics & Performance Tracking
                </h3>
                <p className="text-white">
                  Track message delivery, open rates, and customer responses
                  through detailed analytics. These insights help businesses
                  optimize campaigns for better results.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Scalable Solutions for Every Business Size
                </h3>
                <p className="text-white">
                  Whether you’re a startup or an enterprise, MsgNotifier grows
                  with your needs. Easily scale campaigns without compromising
                  speed, performance, or reliability.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Dedicated Business Support
                </h3>
                <p className="text-white">
                  Our expert support team assists at every step, from setup to
                  campaign optimization. We ensure smooth execution and help
                  businesses achieve consistent WhatsApp marketing success.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FAQContactSection />
      <Footer />
    </div>
  );
}
